import React from "react";
import moment from "moment";
import {
    AppNotificationBackground,
    AppNotificationBody,
    AppNotificationCard,
    AppNotificationHeader,
    AppNotificationPlaceholder,
    AppNotificationTitle,
    PreviewLabel,
    WhatsappBackground,
    WhatsappBubble,
    WhatsappPlaceholder,
    WhatsappTime,
    WhatsappTitle
} from "./AnnouncementPreview.styles";

const withVigoluPlaceholder = text =>
    typeof text === "string" ? text.replaceAll("[Vigolu]", "Ad Soyad") : text;

// Yalnızca <b> etiketi tanınır; backend'deki sanitizeBoldOnly ile aynı kural,
// dengesiz kalan <b>/</b> ham metin olarak gösterilir.
const renderBoldText = text => {
    if (!text) {
        return text;
    }
    const openCount = (text.match(/<b\s*>/gi) || []).length;
    const closeCount = (text.match(/<\/b\s*>/gi) || []).length;
    if (openCount !== closeCount) {
        return text.replace(/<\/?b\s*>/gi, "");
    }
    return text.split(/(<b\s*>.*?<\/b\s*>)/gi).map((part, index) => {
        const match = part.match(/^<b\s*>(.*)<\/b\s*>$/i);
        return match ? <strong key={index}>{match[1]}</strong> : part;
    });
};

// WhatsApp önizlemesi için: yalnızca WhatsApp'ın *kalın*, _italik_ ve
// *_kalın italik_* / _*kalın italik*_ biçimlendirmesi tanınır.
const renderWhatsappFormattedText = text => {
    if (!text) {
        return text;
    }
    return text
        .split(/(\*_[^*_\n]+_\*|_\*[^*_\n]+\*_|\*[^*\n]+\*|_[^_\n]+_)/g)
        .map((part, index) => {
            const boldItalicMatch =
                part.match(/^\*_([^*_\n]+)_\*$/) || part.match(/^_\*([^*_\n]+)\*_$/);
            if (boldItalicMatch) {
                return (
                    <strong key={index}>
                        <em>{boldItalicMatch[1]}</em>
                    </strong>
                );
            }
            const boldMatch = part.match(/^\*([^*\n]+)\*$/);
            if (boldMatch) {
                return <strong key={index}>{boldMatch[1]}</strong>;
            }
            const italicMatch = part.match(/^_([^_\n]+)_$/);
            if (italicMatch) {
                return <em key={index}>{italicMatch[1]}</em>;
            }
            return part;
        });
};

export const AnnouncementPreview = ({channel, title, message}) => {
    if (channel === "whatsapp") {
        return (
            <div>
                <PreviewLabel>Önizleme</PreviewLabel>
                <WhatsappBackground>
                    <WhatsappBubble>
                        {title ? (
                            <WhatsappTitle>{renderWhatsappFormattedText(title)}</WhatsappTitle>
                        ) : (
                            <WhatsappTitle>
                                <WhatsappPlaceholder>Duyuru başlığı</WhatsappPlaceholder>
                            </WhatsappTitle>
                        )}
                        {"Merhaba Ad Soyad,\n\n"}
                        {message ? (
                            renderWhatsappFormattedText(message)
                        ) : (
                            <WhatsappPlaceholder>Duyuru mesajı</WhatsappPlaceholder>
                        )}
                        {"\n\nİyi günler dileriz.\nVigo"}
                        <WhatsappTime>{moment().format("HH:mm")}</WhatsappTime>
                    </WhatsappBubble>
                </WhatsappBackground>
            </div>
        );
    }

    const previewTitle = withVigoluPlaceholder(title);
    const previewMessage = withVigoluPlaceholder(message);

    return (
        <div>
            <PreviewLabel>Önizleme</PreviewLabel>
            <AppNotificationBackground>
                <AppNotificationCard>
                    <AppNotificationHeader>
                        <span>VIGO KURYE</span>
                        <span>şimdi</span>
                    </AppNotificationHeader>
                    <AppNotificationTitle>
                        {previewTitle ? (
                            renderBoldText(previewTitle)
                        ) : (
                            <AppNotificationPlaceholder>Duyuru başlığı</AppNotificationPlaceholder>
                        )}
                    </AppNotificationTitle>
                    <AppNotificationBody>
                        {previewMessage ? (
                            renderBoldText(previewMessage)
                        ) : (
                            <AppNotificationPlaceholder>Duyuru mesajı</AppNotificationPlaceholder>
                        )}
                    </AppNotificationBody>
                </AppNotificationCard>
            </AppNotificationBackground>
        </div>
    );
};
